import React from 'react';
import { Text } from 'react-native';

export const HomeScreen: React.FC = () => <Text>Home</Text>;
